import { UseType } from "src/app/ui/models/domains/pbm/product-management/use-type";
import { AbstractParser } from "../../parser";
import { parseUseTypes } from "./product-management-parse-funtions";

export class UseTypesParser extends AbstractParser<UseType[]> {
  public parse(payload: any): UseType[] {
    return parseUseTypes(payload);
  }
}
